// The DUO A2 Spreken exam date. There is no backend source for this — the
// countdown chip is purely client-derived. Per _DECISIONS.md "no backend"
// rule, this defaults to `null` so the chip is HIDDEN until a real upcoming
// date is set here. Setting it to a future Date re-enables the countdown.
export const EXAM_DATE: Date | null = null;

/** Whole days from now until EXAM_DATE, or null if no date is set / it has
 *  passed. Used to decide whether the countdown chip renders at all. */
export function daysUntilExam(now: Date = new Date()): number | null {
  if (!EXAM_DATE) return null;
  const ms = EXAM_DATE.getTime() - now.getTime();
  const days = Math.ceil(ms / 86_400_000);
  return days > 0 ? days : null;
}
